import React from 'react';
import { Input } from '../../ui/Input';
import { Textarea } from '../../ui/Textarea';
import { ChoiceGroup } from '../ChoiceGroup';
import { practiceStatuses } from '../../../data/practiceOptions';
import { PracticeDraft, PracticeErrors, PracticeStatus } from '../../../types/practice';
interface PracticeStatusFieldsProps {
  draft: PracticeDraft;
  onStatusChange: (status: PracticeStatus) => void;
  onChange: (changes: Partial<PracticeDraft>) => void;
  errors: PracticeErrors;
}
export function PracticeStatusFields({
  draft,
  onStatusChange,
  onChange,
  errors
}: PracticeStatusFieldsProps) {
  return <div className="space-y-5" data-id="element-1505" data-mp="18j6nckrid9t5">
      <ChoiceGroup label="Stato della pratica" name="practice-status" value={draft.status} options={practiceStatuses.map(s => ({
      value: s,
      label: s
    }))} onChange={onStatusChange} data-id="element-1506" data-mp="18iwzp3txreqm" />
      {draft.status === 'Negativo' && <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-1507" data-mp="2ox587uhvfnj9">
          <Input label="Data della non accettazione" type="date" value={draft.rejectionDate || ''} onChange={e => onChange({
        rejectionDate: e.target.value || undefined
      })} error={errors.rejectionDate} required data-id="element-1508" data-mp="1zlwgzny420s9" />
          <div className="md:col-span-2" data-id="element-1509" data-mp="1llby6rs744yr">
            <Textarea label="Motivazione della non accettazione" rows={3} value={draft.rejectionReason || ''} onChange={e => onChange({
          rejectionReason: e.target.value
        })} error={errors.rejectionReason} required data-id="element-1510" data-mp="1lohmi4t032tf" />
          </div>
        </div>}
    </div>;
}